import { GlobalAppContext } from '@juvare/common-web-ui/GlobalApp';
import React from 'react';
import { useInboxClient } from './useInboxClient';
export function useInboxBadge(refreshIntervalMillis = 15000) {
    const globalAppContext = React.useContext(GlobalAppContext);
    const inboxClient = useInboxClient();
    React.useEffect(() => {
        let timeoutId = undefined;
        const updateInboxUnreadBadge = () => {
            inboxClient
                .getList({
                read: false,
                size: 0,
                page: 1,
            })
                .then((response) => {
                globalAppContext.setMenuItemBadge('notifications', response.totalCount > 0 ? response.totalCount : undefined);
            })
                .catch((error) => console.error(error))
                .finally(() => {
                timeoutId = window.setTimeout(updateInboxUnreadBadge, refreshIntervalMillis);
            });
        };
        timeoutId = window.setTimeout(updateInboxUnreadBadge, 0);
        return () => {
            if (timeoutId != null) {
                window.clearTimeout(timeoutId);
            }
        };
    }, [refreshIntervalMillis, globalAppContext, inboxClient]);
}
